import { render, staticRenderFns } from "./DetalheProjeto.vue?vue&type=template&id=fa0d1a6e&scoped=true"
import script from "./DetalheProjeto.vue?vue&type=script&lang=js"
export * from "./DetalheProjeto.vue?vue&type=script&lang=js"
import style0 from "./DetalheProjeto.vue?vue&type=style&index=0&id=fa0d1a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0d1a6e",
  null
  
)

export default component.exports